import { compareAsc, compareDesc } from 'date-fns';
import { JourneyGroupType } from '../types/journey-group';
export const comparePastJourneyGroups = (groupA, groupB) => {
    switch (groupA.type) {
        case JourneyGroupType.LastWeek:
            return groupB.type === JourneyGroupType.LastWeek ? 0 : -1;
        case JourneyGroupType.Monthly:
            if (groupB.type !== JourneyGroupType.Monthly)
                return 1;
            return compareDesc(new Date(groupA.year, groupA.month), new Date(groupB.year, groupB.month));
        default:
            return 0;
    }
};
export const compareCurrentJourneyGroups = (groupA, groupB) => {
    switch (groupA.type) {
        case JourneyGroupType.UpNext:
            return groupB.type === JourneyGroupType.UpNext ? 0 : -1;
        case JourneyGroupType.FoodAndDrink:
            if (groupB.type === JourneyGroupType.UpNext)
                return 1;
            return groupB.type === JourneyGroupType.FoodAndDrink ? 0 : -1;
        case JourneyGroupType.Monthly:
            if (groupB.type !== JourneyGroupType.Monthly)
                return 1;
            return compareAsc(new Date(groupA.year, groupA.month), new Date(groupB.year, groupB.month));
        default:
            return 0;
    }
};
